<template>
  <div>
    <el-form class="selectlesson">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          @change="getlesson"
          placeholder="网校"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          @change="getCourse"
          placeholder="一级分类"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item clearable label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            clearable
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="三级分类">
        <el-select
          clearable
          v-model="model.clID"
          @change="getlesson"
          multiple
          placeholder="三级分类"
        >
          <el-option
            v-for="item in shclass"
            :key="item.clID"
            :label="item.clName"
            :value="item.clID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <template v-show="tableData">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="日期"
          :formatter="formatDate"
          width="150"
        >
        </el-table-column>
        <el-table-column prop="leName" label="名称" width="380">
        </el-table-column>
        <el-table-column prop="teacher" label="讲师">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.teacher" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.teName">{{
                tag.teName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="grade" label="班次">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.grade" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.grName">{{
                tag.grName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="grade" label="原价">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.grade" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.grPrice">{{
                tag.grPrice
              }}</el-tag>
            </span>
          </template>
        </el-table-column>

        <el-table-column prop="grade" label="售价">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.grade" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.salePrice">{{
                tag.salePrice
              }}</el-tag>
            </span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              style="margin: 3px 3px 3px 3px"
              @click="delLesson(scope.row)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
            <el-button
              style="margin: 3px 3px 3px 3px"
              tag="router-link"
              target="_blank"
              @click="editLesson(scope.row._id)"
              type="primary"
              size="small"
              icon="el-icon-edit"
              plain
              >编辑</el-button
            >
            <el-button
              v-if="scope.row.isShow == 1"
              @click="hideLesson(scope.row)"
              style="margin: 3px 3px 3px 3px"
              type="success"
              size="small"
              icon="el-icon-turn-off"
              plain
              >隐藏</el-button
            >
            <el-button
              v-if="scope.row.isShow == 0"
              @click="showLesson(scope.row)"
              style="margin: 3px 3px 3px 3px"
              type="danger"
              size="small"
              icon="el-icon-open"
              plain
              >显示</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </template>
    <el-skeleton :loading="loading" :rows="10" animated />
    <!--  grade分类分页 -->
    <div class="grade-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="lessonpre"
        @next-click="lessonnext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="lessonLength"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { timerfilter } from "../util/timerfilter";
//import moment from 'moment'

export default {
  data() {
    return {
      major: [],
      channel: [],
      course: [],
      shclass: [],
      tableData: [],
      lesson: [],
      model: {},
      sumsId: [],
      sumsName: [],
      loading: true,
      isShow: 1,
      addlesson: {},
      addbooks: {},
      changesums: {},
      lessonLength: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  methods: {
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel(item) {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }

      //this.getlesson(item);
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
        this.getlesson(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.shclass = getclass.data;
        this.getlesson(item);
      } catch (error) {
        console.log(error);
      }
    },
    async getlesson() {
      try {
        const getlesson = await this.$http.get("/lesson/getlesson", {
          params: {
            maID: this.model.maID,
            chID: this.model.chID,
            coID: this.model.coID,
            clID: this.model.clID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });
        this.tableData = getlesson.data[0].result;
        this.lessonLength = getlesson.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    /* async findBooks(item) {
      const onelesson = await this.$http.get(
        "/category/addcontent?_id=" + `${item._id}`
      );
      this.addlesson = onelesson.data;
    }, */
    /* 删除课程 */
    async delLesson(item) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.delete(
            "/lesson/dellesson?_id=" + `${item._id}`
          );

          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.getlesson();
          } else {
            this.$message(res.message);
          }
        })
        .catch((res) => {
          if (res === "cancel") {
            this.$message({
              type: "info",
              message: "取消删除",
            });
          } else {
            //console.log(res);
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        });
    },
    /* 隐藏课程 */
    async hideLesson(item) {
      try {
        const hideLesson = await this.$http.get(
          "/lesson/hidelesson?_id=" + `${item._id}`
        );
        if (hideLesson.status === 200) {
          this.$message({
            type: "success",
            message: hideLesson.data.msg,
          });
          this.isShow = 0;
          this.getlesson();
        }
      } catch (error) {
        //console.log(res);
        this.$message({
          type: "info",
          message: error.message,
        });
      }
    },
    /* 显示课程 */
    async showLesson(item) {
      try {
        const showLesson = await this.$http.get(
          "/lesson/showlesson?_id=" + `${item._id}`
        );
        if (showLesson.status === 200) {
          this.$message({
            type: "success",
            message: showLesson.data.msg,
          });
          this.isShow = 1;
          this.getlesson();
        }
      } catch (error) {
        //console.log(res);
        this.$message({
          type: "info",
          message: error.message,
        });
      }
    },

    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    /* 编辑课程 */
    async editLesson(id) {
      window.open(`/lesson/edit/${id}`, "_blank");
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    //lesson分类分页
    async lessonpre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async lessonnext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getlesson(this.currentPage);
      //console.log(this.currentPage);
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getlesson();
  },
};
</script>

<style scoped>
.selectlesson {
  display: flex;
  justify-content: space-between;
}
.editBooks {
  display: flex;
  justify-content: space-between;
}
</style>
